import React, { useState } from 'react'
import { Box } from '@mui/material'
import '../../../styles/pages.css'
import CreateEnvironment from '../shared/CreateEnvironmentForm'
import { useNavigateTo } from 'infrastructure/routing'
import { useWithErrorNotification } from 'shared/ui/GlobalDialog'
import { makeKiddomPostRequest } from 'infrastructure/api'

function DistrictCreate() {
  const doCreateDistrict = useWithErrorNotification(
    { errorTitle: 'Error Creating District' },
    (requestBody: object) => {
      return makeKiddomPostRequest<{ id: number }>({
        kiddomPath: `/api/district`,
        requestBody,
      })
    },
  )
  const [districtName, setDistrictName] = useState('')
  const [isVerified, setIsVerified] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigateTo()

  const onSubmit = async () => {
    const body = {
      name: districtName,
      is_verified: isVerified,
    }
    try {
      const res = await doCreateDistrict(body)
      if (!res) return
      navigate(`/districts/${res.id}/show`)
    } catch (e: any) {
      setError('Error creating district, please try again.')
    }
  }
  return (
    <Box>
      <CreateEnvironment
        label="District Name"
        updateName={setDistrictName}
        updateVerified={setIsVerified}
        onSubmit={onSubmit}
      />
      <Box m={2}>{error && <p className="error">{error}</p>} </Box>
    </Box>
  )
}

export default DistrictCreate
